import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { EditUserInformationComponent } from './components/edit-user-information/edit-user-information.component';
import { PreRegisterComponent } from './components/pre-register/pre-register.component';
import { StaffDashboardComponent } from './components/staff-dashboard/staff-dashboard.component';
import { UserDashboardComponent } from './components/user-dashboard/user-dashboard.component';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { ReferenceUserDataManagementComponent } from './components/reference-user-data-management/reference-user-data-management.component';
import { RoleManagementComponent } from './components/role-management/role-management.component';
import { OrganizationManagementComponent } from './components/organization-management/organization-management.component';
import { StaffManagementComponent } from './components/staff-management/staff-management.component';
import { CourseManagementComponent } from './components/course-management/course-management.component';
import { ExamManagementComponent } from './components/exam-management/exam-management.component';
import { RequestRegisNewUserManagementComponent } from './components/request-regis-new-user-management/request-regis-new-user-management.component';
import { RequestRenewMemberManagementComponent } from './components/request-renew-member-management/request-renew-member-management.component';
import { RequestRegisNewMemberFormComponent } from './components/request-regis-new-member-form/request-regis-new-member-form.component';
import { RequestRegisNewAppraiserComponent } from './components/request-regis-new-appraiser/request-regis-new-appraiser.component';
import { RequestRegisNewAppraiserFormComponent } from './components/request-regis-new-appraiser-form/request-regis-new-appraiser-form.component';
import { RequestRenewAppraiserComponent } from './components/request-renew-appraiser/request-renew-appraiser.component';
import { RequestRenewAppraiserFormComponent } from './components/request-renew-appraiser-form/request-renew-appraiser-form.component';
import { RequestRenewNewMemberFormComponent } from './components/request-renew-new-member-form/request-renew-new-member-form.component';
import { CpdHoursManagementComponent } from './components/cpd-hours-management/cpd-hours-management.component';
import { CpdCourseDetailComponent } from './components/cpd-course-detail/cpd-course-detail.component';
import { ExamListManagementComponent } from './components/exam-list-management/exam-list-management.component';
import { ExamListDetailComponent } from './components/exam-list-detail/exam-list-detail.component';
import { AccountWorklistComponent } from './components/account-worklist/account-worklist.component';
import { PaymentVerificationComponent } from './components/payment-verification/payment-verification.component';
import { PaymentVerificationDetailComponent } from './components/payment-verification-detail/payment-verification-detail.component';
import { RenewSlipComponent } from './components/renew-slip/renew-slip.component';
import { UserCourseListComponent } from './components/user-course-list/user-course-list.component';
import { UserCourseRegisterComponent } from './components/user-course-register/user-course-register.component';
import { UserExamRegisterComponent } from './components/user-exam-register/user-exam-register.component';
import { UserCheckExamListComponent } from './components/user-check-exam-list/user-check-exam-list.component';
import { AuthGuard, StaffGuard, UserGuard, LoginGuard } from './guards/auth.guard';
import { ForceChangePasswordComponent } from './components/force-change-password/force-change-password.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { MaintainComponent } from './components/maintain/maintain.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'maintain',
    component: MaintainComponent
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard]
  },
  // {
  //    path: 'login',
  //    component: MaintainComponent
  // },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent,
    canActivate: [LoginGuard]
    // Only accessible when not logged in
  },
  {
    path: 'register',
    component: RegisterComponent
    // No guard - allow both authenticated and unauthenticated users
    // Authenticated users need this for completing their user information
  },
  {
    path: 'force-change-password',
    component: ForceChangePasswordComponent,
    canActivate: [AuthGuard]
    // Requires authentication - user must be logged in first before changing password
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [AuthGuard]
    // Requires authentication - user must be logged in to change password
  },
  {
    path: 'edit-user-information',
    component: EditUserInformationComponent,
    canActivate: [AuthGuard]
    // Requires authentication to edit user information
  },
  {
    path: 'pre-register',
    component: PreRegisterComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'staff',
    canActivate: [StaffGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: StaffDashboardComponent
      },
      {
        path: 'user-management',
        component: UserManagementComponent
      },
      {
        path: 'reference-user-data-management',
        component: ReferenceUserDataManagementComponent
      },
      {
        path: 'role-management',
        component: RoleManagementComponent
      },
      {
        path: 'organization-management',
        component: OrganizationManagementComponent
      },
      {
        path: 'staff-management',
        component: StaffManagementComponent
      },
      {
        path: 'course-management',
        component: CourseManagementComponent
      },
      {
        path: 'course-management/view/:id',
        loadComponent: () => import('./components/view-course-modal/view-course-modal.component').then(m => m.ViewCourseModalComponent)
      },
      {
        path: 'course-management/edit/:id',
        loadComponent: () => import('./components/edit-course-modal/edit-course-modal.component').then(m => m.EditCourseModalComponent)
      },
      {
        path: 'exam-management',
        component: ExamManagementComponent
      },
      {
        path: 'exam-management/create',
        loadComponent: () => import('./components/create-exam/create-exam.component').then(m => m.CreateExamComponent)
      },
      {
        path: 'exam-management/edit/:id',
        loadComponent: () => import('./components/edit-exam-modal/edit-exam-modal.component').then(m => m.EditExamModalComponent)
      },
      // TODO: Implement view exam modal component
      // {
      //   path: 'exam-management/view/:id',
      //   loadComponent: () => import('./components/view-exam-modal/view-exam-modal.component').then(m => m.ViewExamModalComponent)
      // },
      {
        path: 'request-regis-new-user-management',
        component: RequestRegisNewUserManagementComponent
      },
      {
        path: 'request-regis-new-member-form/:requestId',
        component: RequestRegisNewMemberFormComponent
      },
      {
        path: 'request-renew-member-management',
        component: RequestRenewMemberManagementComponent
      },
      {
        path: 'request-renew-member-form/:requestId',
        component: RequestRenewNewMemberFormComponent
      },
      {
        path: 'request-regis-new-appraiser',
        component: RequestRegisNewAppraiserComponent
      },
      {
        path: 'request-regis-new-appraiser-form/:requestId',
        component: RequestRegisNewAppraiserFormComponent
      },
      {
        path: 'request-renew-appraiser',
        component: RequestRenewAppraiserComponent
      },
      {
        path: 'request-renew-appraiser-form/:requestId',
        component: RequestRenewAppraiserFormComponent
      },
      {
        path: 'cpd-hours-management',
        component: CpdHoursManagementComponent
      },
      {
        path: 'cpd-hours-management/detail/:id',
        component: CpdCourseDetailComponent
      },
      {
        path: 'exam-list-management',
        component: ExamListManagementComponent
      },
      {
        path: 'exam-list-management/detail/:id',
        component: ExamListDetailComponent
      },
      {
        path: 'payment-verification',
        component: PaymentVerificationComponent
      },
      {
        path: 'payment-verification/detail/:type/:id',
        component: PaymentVerificationDetailComponent
      },
      {
        path: 'account-worklist',
        component: AccountWorklistComponent
      },
      {
        path: 'renew-slip',
        component: RenewSlipComponent
      },
      {
        path: 'renew-slip/:id',
        component: RenewSlipComponent
      }
    ]
  },
  {
    path: 'user',
    canActivate: [UserGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: UserDashboardComponent
      },
      {
        path: 'course-list',
        component: UserCourseListComponent
      },
      {
        path: 'course-register/:id',
        component: UserCourseRegisterComponent
      },
      {
        path: 'exam-register/:id',
        component: UserExamRegisterComponent
      },
      {
        path: 'exam-list',
        component: UserCheckExamListComponent
      },
      {
        path: 'renew-slip',
        component: RenewSlipComponent
      },
      {
        path: 'renew-slip/:id',
        component: RenewSlipComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
